/**
 * The inbound-call default team (ADR-352): which team inbound call follow-ups
 * fall to when no assignment rule claims them (docs/call-follow-ups.md).
 *
 * The flag is per channel, and call work reads the PHONE channel's. So a team
 * that takes inbound calls is a phone team, and turning the switch on moves the
 * team onto that channel in the same save.
 */

export function isInboundCallTeam(team: { channel: string; isInboundDefault: boolean }): boolean {
  return team.channel === 'phone' && team.isInboundDefault;
}

/** The fields an update sends for the switch — nothing when it did not move. */
export function inboundDefaultChange(
  wasDefault: boolean,
  isDefault: boolean
): { channel?: 'phone'; isInboundDefault?: boolean } {
  if (isDefault && !wasDefault) return { channel: 'phone', isInboundDefault: true };
  // Letting go keeps whatever channel the team has.
  if (!isDefault && wasDefault) return { isInboundDefault: false };
  return {};
}

/**
 * Whether some team takes inbound calls AND has somebody on it. Assignment
 * skips a default team with no members (its tasks would be in nobody's "My"),
 * so without one, inbound follow-ups fall to the rules and may stay unassigned.
 */
export function hasStaffedInboundTeam(
  teams: ReadonlyArray<{ channel: string; isInboundDefault: boolean; memberCount: number }>
): boolean {
  return teams.some((team) => isInboundCallTeam(team) && team.memberCount > 0);
}
